import { com } from '@eidu/web'
import useHasPermission from '../../../../permission/useHasPermission'
import { KindViewPageProps } from '../../KindPages'
import EntityAction = com.eidu.entity.permission.EntityAction
import assetResourceLinkKey = com.eidu.entity.assetResourceLinkKey
import EntityTypeKind = com.eidu.entity.type.EntityTypeKind
import PublishableEntityKinds = com.eidu.entity.publish.PublishableEntityKinds

export type IsPublishableResult = {
  publishable: boolean
  reason?: string
  loading: boolean
}

/**
 * Returns whether the current user can publish the given asset. Requires the `PublishAsset` permission and a
 * publishable entity kind. Assets carry their payload directly and need no runtime link; only `Runtime` kinds must
 * carry an `education.trellis.asset.resource` payload link (they are themselves the runtime).
 */
const useIsPublishable = (
  entity: KindViewPageProps['entity'],
  entityType: KindViewPageProps['entityType']
): IsPublishableResult => {
  const { hasPermission, loading } = useHasPermission(entity.entity.id, EntityAction.PublishAsset)

  if (loading) return { publishable: false, loading: true }
  if (!hasPermission) return { publishable: false, reason: 'Missing PublishAsset permission', loading: false }
  if (!PublishableEntityKinds.asJsReadonlySetView().has(entityType.kind))
    return { publishable: false, reason: `Entity kind ${entityType.kind} is not publishable`, loading: false }
  const links = entity.entity.links.asJsReadonlyMapView()
  if (entityType.kind.equals(EntityTypeKind.Companion.Runtime) && !links.get(assetResourceLinkKey))
    return { publishable: false, reason: 'Runtime is missing an asset.resource payload link', loading: false }

  return { publishable: true, loading: false }
}

export default useIsPublishable
